import React from 'react';
import PropTypes from 'prop-types';

import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import PDPPriceSectionUI from './PDPPriceSectionUI';

const PDPPriceSection = ({
  optionPrice = null,
  priceObj,
  productId = null,
  promotion,
  slug = null,
  pdpIsModularBYOProduct = false,
  variant,
}) => {
  const { loading, priceDetails } = usePDPTieredPrice(
    priceObj,
    promotion,
    optionPrice,
    productId,
    slug
  );

  if (loading) {
    return <div className="PDPPriceSection__filler-loading" />;
  }

  return (
    <PDPPriceSectionUI
      price={priceDetails?.priceWithOptionsPrice}
      salePrice={priceDetails?.salePriceWithOptionsPrice}
      leastTieredDiscountedPrice={priceDetails?.leastTieredDiscountedPrice}
      maxTieredDiscountedPrice={priceDetails?.maxTieredDiscountedPrice}
      hasDiscount={priceDetails?.hasDiscount}
      hasTieredDiscount={priceDetails?.hasTieredDiscount}
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      variant={variant}
    />
  );
};

PDPPriceSection.propTypes = {
  optionPrice: PropTypes.number,
  priceObj: PropTypes.shape({
    data: PropTypes.shape({
      price: PropTypes.shape({
        price: PropTypes.number,
        optionPrice: PropTypes.number,
        promotion: PropTypes.shape({
          discount: PropTypes.number,
          discountType: PropTypes.string,
        }),
        isClearance: PropTypes.bool,
      }),
    }),
  }),
  productId: PropTypes.number,
  promotion: PropTypes.shape({
    discount: PropTypes.number,
    discountType: PropTypes.string,
  }),
  slug: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  variant: PropTypes.oneOf(['PDPExtraOptionSelector', 'PDPUpSellFlyOut']),
};

export default PDPPriceSection;
